import React from "react";
import "../../App.css";
import i18next from "../../i18n";
import { Helmet } from "react-helmet-async";
import article_img from "../../images/articles/elena-koycheva-bGeupv246bM-unsplash.jpeg";

function CustomerDocsTelecom() {
  return (
    <div className="min-h-screen bg-white">
      <Helmet>
        <title>{i18next.t("pages.articles.list.customerDocsTelecom.title")}</title>
        <meta
          name="description"
          content={i18next.t("pages.articles.list.customerDocsTelecom.description")}
        />
        <link
          rel="canonical"
          href="https://xperconsulting.no/artikler/kundedokumenter-kundeservice-telekom"
        />
      </Helmet>

      <div className="container max-w-xl pt-36 justify-start items-center text-main-dark flex flex-col md:flex-row pb-24 md:gap-16">
        <div className="w-full md:w-3/5 text-left">
          <h1 className="text-5xl font-bold text-main-dark mb-2">
            {i18next.t("pages.articles.list.customerDocsTelecom.title")}
          </h1>
          <p className="text-xl mb-2">
            {i18next.t("pages.articles.list.customerDocsTelecom.description")}
            <a href="/docengine" className="underline hover:text-contrast-ink">{i18next.t("pages.articles.list.customerDocsTelecom.description-link")}</a>
            {i18next.t("pages.articles.list.customerDocsTelecom.description-2")}
          </p>
          <p className="text-lg text-secondary">
            {i18next.t("pages.articles.list.customerDocsTelecom.date")}
          </p>
        </div>
        <div className="w-full md:w-2/5 text-left">
          <img
            className="w-full h-full object-cover"
            src={article_img}
            alt={i18next.t("pages.articles.list.customerDocsTelecom.imageAlt")}
          />
          <p className="text-sm text-secondary mt-2">
            {i18next.t("pages.articles.credit.photoBy")}{" "}
            <a
              href="https://unsplash.com/@lenneek?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText"
              className="underline hover:text-contrast-ink"
              target="_blank"
              rel="noopener noreferrer"
            >
              Elena Koycheva
            </a>{" "}
            {i18next.t("pages.articles.credit.from")}{" "}
            <a
              href="https://unsplash.com/photos/person-holding-black-rotary-telephone-bGeupv246bM?utm_source=unsplash&utm_medium=referral&utm_content=creditCopyText"
              className="underline hover:text-contrast-ink"
              target="_blank"
              rel="noopener noreferrer"
            >
              Unsplash
            </a>
          </p>
        </div>
      </div>

      <div className="bg-gray">
        <div className="container max-w-xl text-xl text-left py-24 text-main-dark">
          <div className="max-w-sm">
            <h2 className="text-3xl font-bold mt-12 mb-4">
              {i18next.t("pages.articles.list.customerDocsTelecom.sections.customerService.title")}
            </h2>
            <p className="mb-8">
              {i18next.t("pages.articles.list.customerDocsTelecom.sections.customerService.content1")}
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-4">
              {i18next.t("pages.articles.list.customerDocsTelecom.sections.oldPdfs.title")}
            </h2>
            <p className="mb-8">
              {i18next.t("pages.articles.list.customerDocsTelecom.sections.oldPdfs.content1")}
              <a href="/artikler/tilgjengelighetsdirektivet" className="underline font-bold hover:text-contrast-ink">
                {i18next.t("pages.articles.list.customerDocsTelecom.sections.oldPdfs.link")}
              </a>
              {i18next.t("pages.articles.list.customerDocsTelecom.sections.oldPdfs.content2")}
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-4">
              {i18next.t("pages.articles.list.customerDocsTelecom.sections.howTo.title")}
            </h2>
            <p className="mb-4">
              {i18next.t("pages.articles.list.customerDocsTelecom.sections.howTo.content1")}
            </p>
            <p className="mb-6">
              {i18next.t("pages.articles.list.customerDocsTelecom.sections.howTo.content2")}
              <a href="/docengine" className="underline font-bold hover:text-contrast-ink">
                {i18next.t("pages.articles.list.customerDocsTelecom.sections.howTo.link")}
              </a>
              {i18next.t("pages.articles.list.customerDocsTelecom.sections.howTo.content3")}
            </p>
            <p className="mb-2">
              {i18next.t("pages.articles.list.customerDocsTelecom.sections.howTo.content4")}
            </p>
            <ul className="list-disc ml-6 mb-8">
              <li>{i18next.t("pages.articles.list.customerDocsTelecom.sections.howTo.features.1")}</li>
              <li>{i18next.t("pages.articles.list.customerDocsTelecom.sections.howTo.features.2")}</li>
              <li>{i18next.t("pages.articles.list.customerDocsTelecom.sections.howTo.features.3")}</li>
            </ul>

            <h2 className="text-3xl font-bold mt-12 mb-4">
              {i18next.t("pages.articles.list.customerDocsTelecom.sections.advantage.title")}
            </h2>
            <p className="mb-12">
              {i18next.t("pages.articles.list.customerDocsTelecom.sections.advantage.content")}
            </p>

            <h2 className="text-3xl font-bold mt-12 mb-4">
              {i18next.t("pages.articles.list.customerDocsTelecom.sections.advice.title")}
            </h2>
            <p className="mb-2">
              {i18next.t("pages.articles.list.customerDocsTelecom.sections.advice.content1")}
            </p>
            <p className="mb-8">
            <a href="/skjema/kontakt-oss" className="underline font-bold hover:text-contrast-ink">
                {i18next.t("pages.articles.list.customerDocsTelecom.sections.advice.content2-link")}
              </a>
              {i18next.t("pages.articles.list.customerDocsTelecom.sections.advice.content2")}
              
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomerDocsTelecom;


